import { Component, OnInit, ViewChild } from '@angular/core';
import { DeviceHistoryComponent } from '../device-history/device-history.component';
import { StorageService } from 'src/app/services/storage.service';
import { CoverageItem } from 'src/app/model/coverage-item';
import { ClientItem } from 'src/app/model/client-item';
import { CommonService } from 'src/app/services/common.service';
import { MSSPService } from 'src/app/services/mssp.service';
import { RegisterDevice } from 'src/app/model/register-device';
import { CoverageItemPolicy, PolicyDetailItem, RegisteredDeviceItem } from 'src/app/model/policy-detail-item';
import { RequestIntegrationItem } from 'src/app/model/client-policy-detail';
import { CertificateItem } from 'src/app/model/certificate-item';


@Component({
  selector: 'app-device',
  templateUrl: './device.component.html',
  styleUrls: ['./device.component.scss']
})
export class DeviceComponent implements OnInit {
  @ViewChild(DeviceHistoryComponent)
  public deviceHistory!: DeviceHistoryComponent;
  panelOpenState = false;
  clientItems: Array<RequestIntegrationItem> = [];
  datosGenerales!: any[];
  loading: boolean = false
  // items!: any[];
  msspItem!: CoverageItemPolicy;
  policy: string = ""
  idCliente: string = ""
  apikey: string = ""
  client: string = ""
  certificate: string = ""
  today: Date = new Date()
  config: any;

  constructor(
    private storageService: StorageService,
    private commonService: CommonService,
    private msspService: MSSPService,
  ) {
    this.policy = this.storageService.getData('policy');
    this.idCliente = this.storageService.getData('idClient');
    this.apikey = this.storageService.getData('apiKey');
    this.client = this.storageService.getData('client');
    this.certificate = this.storageService.getData('certificado');
  }

  ngOnInit(): void {
    this.commonService.dealerCode ||= this.storageService.getData('dealerCode');
    this.loading = true;
    // reqClient -- proceso liverpool
    // reqMssp -- elita

    if (this.commonService.dealerCode !== 'EA113') {
      this.commonService.getlistProducts(this.policy, this.idCliente, this.apikey, this.client, this.certificate, this.commonService.deviceId, this.commonService.dealerCode).subscribe(({ reqClient, reqMssp }) => {

        if (!Array.isArray(reqMssp.data)) {
          if (typeof reqMssp.data === 'object' && typeof reqClient.data === 'object') {
            this.commonService.reqMsspData = reqMssp.data;
            this.commonService.reqClientData = reqClient.data;

            let msspPendingClaim: any;

            
            const coverageMssp = this.commonService.reqMsspData.Coverages.find(this.commonService.typeValidation);
            
            if (typeof coverageMssp !== 'undefined') {
              this.msspItem = coverageMssp;
            }
          
            this.msspService.GetAllDealerCodeByClient(this.idCliente, 'ExternalURL').subscribe(response => {
              console.log("response", response);
              //this.config = response.filteredResponse.filter((response: any) => typeof response == "object");

              //if (this.config[0].IsExternal) {
                // ToDo modificar a variable de servicio
                // this.clientItems = this.commonService.capitalLetter(reqClient?.data?.RequestIntegration)

                // this.commonService.reqClientData.RequestIntegration.every((r, index) => {

                //   if (index % 3 === 0) {
                //     r.R3Fechaservicio = "11/10/2021"
                //   } else if (index % 2 === 0) {
                //     r.R3Fechaservicio = "11/10/2022"
                //   } else {
                //     r.R3Fechaservicio = "11/10/2020"
                //   }
                //   r.EstadoGarantia = "";
                //   r.R3Fechaterminollamada = "";
                //   r.R3Fechaasignacion = "";
                  
                //   return r;
                // });
                
                this.clientItems = this.commonService.capitalLetter(this.commonService.reqClientData.RequestIntegration);
                // this.setClientInfo(reqClient?.data)
                let clientName: string = "";
                if (typeof this.commonService.reqClientData.PrimFirstName === 'string' && this.commonService.reqClientData.PrimFirstName.length > 0) {
                  clientName = this.commonService.reqClientData.PrimFirstName;
                } else {
                  if (this.commonService.reqMsspData.Customers.length > 0 && typeof this.commonService.reqMsspData.Customers[0].CustomerName  === 'string') {
                    const splittedName: Array<string> = this.commonService.reqMsspData.Customers[0].CustomerName.split(' ');
                    if (splittedName.length > 0) {
                      clientName = this.commonService.reqMsspData.Customers[0].CustomerName;
                    } else {
                      
                      if (typeof this.commonService.reqMsspData.Customers[0].FirstName === 'string' && this.commonService.reqMsspData.Customers[0].FirstName.length > 0) {
                        clientName += this.commonService.reqMsspData.Customers[0].FirstName
                      }

                      if (typeof this.commonService.reqMsspData.Customers[0].MiddleName === 'string' && this.commonService.reqMsspData.Customers[0].MiddleName.length > 0) {
                        clientName += ` ${this.commonService.reqMsspData.Customers[0].MiddleName}`
                      }

                      if (typeof this.commonService.reqMsspData.Customers[0].LastName === 'string' && this.commonService.reqMsspData.Customers[0].LastName.length > 0) {
                        clientName += ` ${this.commonService.reqMsspData.Customers[0].LastName}`
                      }
                    }
                  }
                }

                this.setClientInfo(clientName)
                this.validateCoverageEndDate();
                // this.sortByDate()
                this.sortByStatus();
              // }
              
              // else {

              //     // reqMssp.data.ItemInfo[0].RegisteredDevices.forEach((res: any) => {
              //     this.commonService.reqMsspData.ItemInfo.forEach((res: any) => {
              //     var dateArray = res.ItemEffectiveDate.split("T")[0] //res.DevicePurchaseDate.split(" ")[0]
              //     var initial = dateArray.split("-")
              //     //dateArray = [ (Number(initial[2]) < 9) ? '0' + initial[2] : initial[2], (Number(initial[1]) < 9) ? '0' + initial[1] : initial[1], initial[0]].join('/')
              //     dateArray = [ initial[2], initial[1], initial[0]].join('/')
              //     //var infoModel = res.Model.split("//")
              //     // var clientItem = new ClientItem(
              //     //   res.RegisteredDeviceName,
              //     //   "",
              //     //   res.Model,
              //     //   dateArray,
              //     //   "",
              //     //   res.Make,
              //     //   Number(res.DevicePurChasePrice),
              //     //   res.ItemDescription,
              //     //   "",
              //     //   res.Make,
              //     //   [],
              //     //   true,
              //     //   false
              //     // )
              //     const clientItem: RequestIntegrationItem = {
              //       SRNumber: res.SerialNumber,
              //       Area: '',
              //       SubArea: res.Model,
              //       R3Fechaservicio: dateArray,
              //       INSProduct: '',
              //       TipoAclaracion: res.Make,
              //       ContactEmail: Number(res.DevicePurChasePrice),
              //       Abstract: res.ItemDescription,
              //       Created: '',
              //       R3Idproveedor: res.Make,
              //       EstadoGarantia: "",
              //       R3Fechaterminollamada: "",
              //       R3Fechaasignacion: "",
              //       RequestNotes: [],
              //       ShowButton: true,
              //       DisableButton: false
              //     }
              //     this.clientItems.push(clientItem)


              //   });

              //   // this.setClientInfo(reqMssp.data)
              //   this.setClientInfo(this.commonService.reqMsspData);
              //   this.validateCoverageEndDate();
              //   this.sortByDate();
                
              // }

              if (!this.commonService.isMultipleCertificate) {
                msspPendingClaim = this.getDifferences(this.commonService.reqMsspData.ItemInfo[0].RegisteredDevices, this.clientItems);

                this.msspService.getSearchClaim(reqMssp.data.CertificateNumber, reqMssp.data.DealerCode, this.idCliente).subscribe((reqMssp) => {
                  if (reqMssp.data) {
                    this.validateNonOpenClaim(reqMssp.data)
                    if (msspPendingClaim != null)
                      this.validateStatus(msspPendingClaim, reqMssp.data)

                    this.loading = false
                    this.datosGenerales = reqMssp.data;
                  } else {
                    this.loading = false
                    this.datosGenerales = [];
                  }
                })
              } else {
                this.datosGenerales = [];
                this.msspService.getPolicy(this.policy, this.idCliente, this.certificate, this.commonService.isMultipleCertificate, this.commonService.dealerCode, 'array').subscribe(respPol => {
                  const certificates = respPol.data as Array<CertificateItem>;
                  let certificatesDetail: Array<PolicyDetailItem> = [];

                  const getCertificateDetail = (): void => {

                    if (certificates.length > 0) {
                      const cert = certificates.splice(0, 1)[0];
                      this.msspService.getDetails(this.idCliente, cert.CertificateNumber, this.commonService.dealerCode, this.commonService.deviceId, this.policy).subscribe(respDet => {
                        certificatesDetail.push(respDet.data);
                        setTimeout(getCertificateDetail, 0);
                      })
                    } else {
                      let clonedClientItems: Array<RequestIntegrationItem> = [];
                      const getClaimByItem = ():void => {
                        if (this.clientItems.length > 0) {
                          const claims: Array<any> = [];
                          const item = this.clientItems.splice(0,1)[0];
                          clonedClientItems.push(item);
                          const relatedCertificates = certificatesDetail.filter((detail, i) => {
                            const existsItem = detail.ItemInfo[0].RegisteredDevices.some(r => r.SerialNumber === item.SRNumber || r.RegisteredDeviceName === item.SRNumber);
                            if (existsItem) {
                              return true
                            }
                            return false;
                          });

                          const getclaims = ():void => {
                            if (relatedCertificates.length > 0) {
                              const relCert = relatedCertificates.splice(0, 1)[0];
                              this.msspService.getSearchClaim(this.policy, relCert.CertificateNumber, this.idCliente).subscribe((respClaim) => {
                                if (!Array.isArray(respClaim)) {
                                  const certificateClaims = respClaim.data as Array<any>;
                                  certificateClaims.filter((cc, icc) => {
                                    if (cc.StatusCode === 'P' || cc.StatusCode === 'A'){
                                      return true;
                                    }
                                    return false;
                                  }).forEach((claim, ic) => {
                                    this.datosGenerales.push(claim);
                                  });
                                  getclaims();   
                                } else {
                                  getclaims();
                                }           
                              })
                            } else {
                              getClaimByItem();
                            }
                          }
                          getclaims();
                        } else {
                          this.clientItems = clonedClientItems;
                          this.loading = false;
                        }
                      }
                      getClaimByItem();
                    }
                  }

                  getCertificateDetail();

                });  
              }
            });
          }
        }
      })
    } else {
      this.configMasGarantia().then(result => {
        if (result) {
          this.loading = false;
        } else {
          alert("Ocurrio un error al obtener los articulos");
        }
      })
    }
    

  }

  async configMasGarantia(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.msspService.getDetails(this.idCliente, this.certificate, this.commonService.dealerCode, this.commonService.deviceId, this.policy).subscribe(resp => {
        console.log(resp);
      })
    })
  }

  getDataHistory(serialNumber: string) {
    var items = []
    var StateFilter = []
    if (this.datosGenerales.length > 0) {
      items = this.datosGenerales.filter((res: any) => {
        if (res.ClaimEquipment != null)
          return res.ClaimEquipment.ClaimedEquipment.SerialNumber === serialNumber || res.ClaimEquipment.ClaimedEquipment.RegisteredName === serialNumber
        return
      })
    }
    return items;
  }

  getDataStatus(serialNumber: string) {
    var items = []
    var firstItem = []
    var StateFilter = []
    var StateGral = ""
    if (this.datosGenerales?.length > 0) {
      items = this.datosGenerales?.filter((res: any) => {
        if (res.ClaimEquipment != null)
          return (res.ClaimEquipment.ClaimedEquipment.SerialNumber === serialNumber || res.ClaimEquipment.ClaimedEquipment.RegisteredName === serialNumber) && res.ClaimNumber != ""
        return
      })
    }
    StateFilter = this.datosGenerales?.filter((res: any) => {
      if (res.ClaimEquipment != null)
        return (res.ClaimEquipment.ClaimedEquipment.SerialNumber === serialNumber || res.ClaimEquipment.ClaimedEquipment.RegisteredName === serialNumber) && (res.ClaimStatus == "A" || res.ClaimStatus == 'P') && res.ClaimNumber != ""
      return
    })

    firstItem = items?.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => a["CreatedDate"] > b["CreatedDate"] ? 1 : a["CreatedDate"] === b["CreatedDate"] ? 0 : -1);
    if (StateFilter?.length == 0 && items.length >= 1) {
      return StateGral = 'Finalizada' + '|' + firstItem[0]?.ClaimNumber
    }
    if (StateFilter?.length >= 1 && items.length >= 1) {
      return StateGral = 'En proceso' + '|' + firstItem[0]?.ClaimNumber
    }
    return StateGral;

  }



  setClientInfo(ClientName: string) {
    // let customerArr: any;
    // if (typeof data.PrimFirstName === 'undefined') {
    //   customerArr = data.Customers[0].CustomerName.trim().split(" ")
    // }
    // else {
    //   customerArr = data?.PrimFirstName?.trim().split(" ")
    // }

    this.storageService.saveData('userName', ClientName);

    ClientName.split(' ').forEach((res: any, index: any) => {
      if (index == 0) {
        this.commonService.firstName = res[0].toUpperCase() + res.substr(1).toLowerCase()
      } else if (index == 1) {
        this.commonService.lastName = res[0].toUpperCase() + res.substr(1).toLowerCase()
      } else {
        if (this.commonService.secondLastName) {
          this.commonService.secondLastName += " " + res[0].toUpperCase() + res.substr(1).toLowerCase()
          return
        }
        this.commonService.secondLastName = res[0].toUpperCase() + res.substr(1).toLowerCase()
      }
    })
  }

  getDifferences(msspRegister: Array<RegisteredDeviceItem>, clientItem: Array<RequestIntegrationItem>): Array<RegisteredDeviceItem> | null {
    if (msspRegister.length != 0 && clientItem.length != 0) {
      return msspRegister.filter(mssp => {
        return !clientItem.some(client => {
          return (mssp.SerialNumber == client.SRNumber) || (mssp.RegisteredDeviceName == client.SRNumber)
        })
      })
    }
    return null
  }

  validateStatus(msspRegister: RegisterDevice[], claimsByCertificate: any) {
    var filterRegister = msspRegister.filter((mssp: RegisterDevice) => {
      var find = claimsByCertificate.find((claims: any) => claims.ClaimEquipment && (mssp.SerialNumber == claims.ClaimEquipment.ClaimedEquipment.SerialNumber || mssp.RegisteredDeviceName == claims.ClaimEquipment.ClaimedEquipment.RegisteredName) && claims.StatusCode == 'P')
      if (find) return true
      return false
    })
    if (filterRegister) {
      filterRegister.forEach((res) => {
        var dateArray = res.DevicePurchaseDate.split(" ")[0]
        //var infoModel = res.Model.split("//")
        // var clientItem = new ClientItem(
        //   res.RegisteredDeviceName,
        //   '',
        //   res.Model,
        //   dateArray,
        //   "",
        //   res.Make,
        //   Number(res.DevicePurChasePrice),
        //   res.ItemDescription,
        //   "",
        //   res.Make,
        //   [],
        //   false
        // )
        const clientItem: RequestIntegrationItem = {
          SRNumber: res.RegisteredDeviceName,
          Area: '',
          SubArea: res.Model,
          R3Fechaservicio: dateArray,
          INSProduct: '',
          TipoAclaracion: res.Make,
          ContactEmail: Number(res.DevicePurChasePrice),
          Abstract: res.ItemDescription,
          Created: '',
          R3Idproveedor: res.Make,
          EstadoGarantia: '',
          R3Fechaterminollamada: '',
          R3Fechaasignacion: '',
          RequestNotes: [],
          ShowButton: false,
          DisableButton: false
        }
        this.clientItems.push(clientItem)
      })
    }
  }

  validateNonOpenClaim(msspClaims: any) {
    var noValid = msspClaims.filter((res: any) => {
      if (res.StatusCode == 'P' || res.StatusCode == 'A')
        return true
      return false
    })
    if (noValid && noValid.length > 0) {
      noValid.forEach((noValidItem: any) => {
        this.clientItems = this.clientItems.map((res: RequestIntegrationItem) => {
          if (res.SRNumber == noValidItem.ClaimEquipmentList[0].ClaimedEquipment.SerialNumber || res.SRNumber == noValidItem.ClaimEquipmentList[0].ClaimedEquipment.RegisteredName)
            res.DisableButton = true
          return res
        })
      })
    }
  }

  validateCoverageEndDate() {
    this.clientItems = this.clientItems.map((res: RequestIntegrationItem) => {
      if (res.EstadoGarantia === 'Fin de vigencia') {
        res.ShowButton = false;
      }
      return res;
    })
  }

  addYears(initDate: string) {
    var dateParts: any = initDate.split('/')
    var newDate = new Date(+dateParts[2], dateParts[1] - 1, dateParts[0])
    newDate.setFullYear(newDate.getFullYear() + 2)
    this.commonService.endDate = newDate
    return newDate
  }

  sortByDate() {
    this.clientItems = this.clientItems.sort((a, b) => {
      const newA = a.R3Fechaservicio.split('/').reverse().join('-');
      const newB = b.R3Fechaservicio.split('/').reverse().join('-');
      if (+new Date(newA) < +new Date(newB))
        return 1
      else if (+new Date(newA) === +new Date(newB))
        return 0
      else
        return -1
    })
  }

  sortByStatus(): void {
    const filteredStatusPIF = this.clientItems.filter(p => p.EstadoGarantia === 'Garantía +G PIF').sort((a, b) => {
      const splittedDate_a = a.R3Fechaasignacion.split('/');
      const splittedDate_b = b.R3Fechaasignacion.split('/');

      const date_a: Date = new Date(Number(splittedDate_a[2]), Number(splittedDate_a[1]), Number(splittedDate_a[0]));
      const date_b: Date = new Date(Number(splittedDate_b[2]), Number(splittedDate_b[1]), Number(splittedDate_b[0]));

      if (date_b.getTime() > date_a.getTime()) {
        return -1
      } else {
        return 1
      }
    });
    const filteredStatusMaker = this.clientItems.filter(m => m.EstadoGarantia === 'Garantía Fabricante').sort((a,b) => {
      const splittedDate_a = a.R3Fechaterminollamada.split('/');
      const splittedDate_b = b.R3Fechaterminollamada.split('/');

      const date_a: Date = new Date(Number(splittedDate_a[2]), Number(splittedDate_a[1]), Number(splittedDate_a[0]));
      const date_b: Date = new Date(Number(splittedDate_b[2]), Number(splittedDate_b[1]), Number(splittedDate_b[0]));

      if (date_b.getTime() > date_a.getTime()) {
        return -1
      } else {
        return 1
      }
    });
    const filteredEndWarranty = this.clientItems.filter(w => w.EstadoGarantia === 'Fin de vigencia').sort((a, b) => {
      const splittedDate_a = a.R3Fechaasignacion.split('/');
      const splittedDate_b = b.R3Fechaasignacion.split('/');

      const date_a: Date = new Date(Number(splittedDate_a[2]), Number(splittedDate_a[1]), Number(splittedDate_a[0]));
      const date_b: Date = new Date(Number(splittedDate_b[2]), Number(splittedDate_b[1]), Number(splittedDate_b[0]));

      if (date_b.getTime() > date_a.getTime()) {
        return -1
      } else {
        return 1
      }
    });
    this.clientItems = [];
    this.clientItems = [...filteredStatusPIF, ...filteredStatusMaker, ...filteredEndWarranty];
  }
}
